// extracted by mini-css-extract-plugin
module.exports = {"container":"RecommendList_container__vpsNL","filter":"RecommendList_filter__1rmVv","list":"RecommendList_list__LoV9n"};